;(() => {
  function noscrollIOSShift() {
    const docEl = document.documentElement
    if (
      docEl.classList.contains("ios") &&
      document.body.classList.contains("noscroll")
    ) {
      return docEl.scrollTop
    }

    return 0
  }

  window.HB = window.HB || {}
  window.HB.noscrollIOSShift = noscrollIOSShift
})()
